import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/PageContent";
import getToken from "app/api/getToken";

import { IPageContent } from "app/api/types";

export const ADD_PAGE_CONTENT_REQUEST = "ADD_PAGE_CONTENT_REQUEST";
export const ADD_PAGE_CONTENT_SUCCESS = "ADD_PAGE_CONTENT_SUCCESS";
export const ADD_PAGE_CONTENT_FAIL = "ADD_PAGE_CONTENT_FAIL";

export const addPageContent = (data: IPageContent) => (dispatch: any): any => {
  dispatch({ type: ADD_PAGE_CONTENT_REQUEST });

  const token = getToken();

  return api
    .addPageContent(token, data)
    .then((response: AxiosResponse) => {
      const pageContent: IPageContent = get(response, "data", {});
      dispatch({ type: ADD_PAGE_CONTENT_SUCCESS, payload: pageContent });

      return pageContent;
    })
    .catch(err => {
      dispatch({
        type: ADD_PAGE_CONTENT_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
